import { BRAND_LABEL } from '@moonpig/web-core-brand/config'

export const buildSearchTitle = (
  baseTitle: string,
  page: number,
  pageLabel: string,
): string =>
  page > 1
    ? `${baseTitle} - ${pageLabel} ${page} | ${BRAND_LABEL}`
    : `${baseTitle} | ${BRAND_LABEL}`
